import React from 'react';
import { IIconProps } from '../IIconProps';

export const SurveyTrackingIcon = ({
	iconClass = '',
	title = '',
	pointer,
}: IIconProps) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			className={`${iconClass} ${pointer ? 'icon--pointer' : ''}`}
			fill="none"
		>
			{title && <title>{title}</title>}
			<rect x="0.5" y="2.5" width="23" height="18" stroke="currentColor" />
			<path d="M9 8H4V11H9" stroke="currentColor" />
			<path d="M15 8H20V11H15" stroke="currentColor" />
			<path d="M10 8H14" stroke="currentColor" />
			<path d="M10 11H14" stroke="currentColor" />
			<path d="M9 14H4V17H9" stroke="currentColor" />
			<path d="M15 14H20V17H15" stroke="currentColor" />
			<path d="M10 14H14" stroke="currentColor" />
			<path d="M10 17H14" stroke="currentColor" />
			<line x1="1" y1="4.5" x2="23" y2="4.5" stroke="currentColor" />
		</svg>
	);
};
